import { useState } from "react";
import axiosInstance from "../store/api/axiosInstance";

const useApiPost = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [data, setData] = useState(null);
  const [progress, setProgress] = useState(0);

  const postData = async (
    url: string,
    bodyData: unknown,
    contentType = "application/json",
  ) => {
    try {
      setLoading(true);
      setError(null);
      setProgress(0);

      const response = await axiosInstance.post(url, bodyData, {
        headers: {
          "Content-Type": contentType,
          "x-custom-header": "Web",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total!,
          );
          setProgress(percentCompleted);
        },
      });

      setData(response.data);
      return response.data;
    } catch (err: unknown) {
      setError(err as null);
      throw err;
    } finally {
      setLoading(false);
      setProgress(0);
    }
  };

  return { loading, error, data, progress, postData };
};

export default useApiPost;
